/*============================================================================
  Special Day Cart Sync - Optimized
==============================================================================*/

(function() {
  'use strict';

  const SpecialDayCartSync = {
    syncInterval: null,

    init: function() {
      const self = this;
      
      // Bind events
      ['cart:open', 'ajaxProduct:added'].forEach(function(event) {
        document.addEventListener(event, function() {
          if (self.isCartOpenOrCartPage()) self.startSyncInterval();
        });
      });
      
      document.addEventListener('cart:close', this.stopSyncInterval.bind(this));
      
      // Start immediately if on cart page
      if (document.body.classList.contains('template-cart')) {
        this.startSyncInterval();
      }

      this.observeCartStateChanges();
    },

    startSyncInterval: function() {
      this.stopSyncInterval(); // Clear any existing interval
      this.syncInterval = setInterval(this.checkAndSyncSpecialDayProducts.bind(this), 2000);
    },

    stopSyncInterval: function() {
      if (this.syncInterval) {
        clearInterval(this.syncInterval);
        this.syncInterval = null;
      }
    },

    isCartOpenOrCartPage: function() {
      return document.documentElement.classList.contains('js-drawer-open') ||
             document.documentElement.classList.contains('cart-open') ||
             document.querySelector('#CartDrawer.drawer--is-open') ||
             document.body.classList.contains('template-cart');
    },

    checkAndSyncSpecialDayProducts: function() {
      if (!this.isCartOpenOrCartPage() || typeof theme === 'undefined' || !theme.cart) return;

      theme.cart.getCart().then(function(cart) {
        if (!cart || !cart.items || cart.items.length === 0) return;
        this.syncCartItems(cart.items);
      }.bind(this)).catch(function() {});
    },

    syncCartItems: function(items) {
      let mainProducts = [], additionProducts = [];

      // Categorize items in one pass
      items.forEach(function(item) {
        if (item.properties && item.properties._specialDay) {
          mainProducts.push({
            item: item,
            specialDayId: item.properties._specialDay,
            quantity: item.quantity,
            bundleId: item.properties._bundleId || item.properties.bundleId
          });
        } else if (item.properties && (item.properties._additionBundleId || item.properties.additionBundleId)) {
          additionProducts.push({
            item: item,
            bundleId: item.properties._additionBundleId || item.properties.additionBundleId,
            quantity: item.quantity,
            variantId: item.id
          });
        }
      });

      // Process main products and remove orphans
      mainProducts.forEach(function(mainProduct) {
        this.processMainProduct(mainProduct, additionProducts);
      }.bind(this));

      this.removeOrphanedAdditions(additionProducts, mainProducts);
    },

    processMainProduct: function(mainProduct, additionProducts) {
      const specialDayId = mainProduct.specialDayId;
      const mainQuantity = mainProduct.quantity;
      const matchingAdditions = additionProducts.filter(function(addition) {
        return addition.item.id == specialDayId;
      });

      if (matchingAdditions.length === 0) {
        this.addSpecialDayProduct(specialDayId, mainQuantity, mainProduct.bundleId || this.generateBundleId());
      } else {
        matchingAdditions.forEach(function(addition) {
          if (addition.quantity !== mainQuantity) {
            this.updateSpecialDayProductQuantity(addition.item.key, mainQuantity);
          }
        }.bind(this));
      }
    },

    removeOrphanedAdditions: function(additionProducts, mainProducts) {
      additionProducts.forEach(function(addition) {
        const hasMatchingMain = mainProducts.some(function(main) {
          return main.specialDayId == addition.item.id;
        });
        if (!hasMatchingMain) this.removeSpecialDayProduct(addition.item.key);
      }.bind(this));
    },

    addSpecialDayProduct: function(specialDayId, quantity, bundleId) {
      if (typeof theme === 'undefined' || !theme.routes) return;

      this.fetchCartUpdate(theme.routes.cartAdd, {
        id: parseInt(specialDayId, 10),
        quantity: quantity,
        properties: { '_additionBundleId': bundleId }
      });
    },

    updateSpecialDayProductQuantity: function(itemKey, newQuantity) {
      if (typeof theme === 'undefined' || !theme.cart) return;
      
      theme.cart.changeItem(itemKey, newQuantity)
        .then(function() { document.dispatchEvent(new CustomEvent('cart:build')); })
        .catch(function() {});
    },

    removeSpecialDayProduct: function(itemKey) {
      this.updateSpecialDayProductQuantity(itemKey, 0);
    },

    fetchCartUpdate: function(url, data) {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.status !== 422) {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
      })
      .catch(function() {});
    },

    generateBundleId: function() {
      return new Date().getTime().toString();
    },

    observeCartStateChanges: function() {
      const self = this;
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isOpen = self.isCartOpenOrCartPage();
            if (isOpen && !self.syncInterval) {
              self.startSyncInterval();
            } else if (!isOpen && self.syncInterval) {
              self.stopSyncInterval();
            }
          }
        });
      });

      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', SpecialDayCartSync.init.bind(SpecialDayCartSync));
  } else {
    SpecialDayCartSync.init();
  }

})();
